import React, { ComponentPropsWithoutRef } from 'react';
import { useAppConfig } from '@modules/layout/layout/components/AppConfigProvider';
import useMarkdownListStyles from './MarkdownList.styles';

type ListItemProps = ComponentPropsWithoutRef<'ul'>;

export default function MarkdownUnorderedList({ children, ...otherProps }: ListItemProps) {
  const { enableEngineReferenceRevamp } = useAppConfig();
  const {
    classes: { listContainer },
  } = useMarkdownListStyles({ enableEngineReferenceRevamp: !!enableEngineReferenceRevamp });

  return (
    <ul {...otherProps} className={listContainer}>
      {children}
    </ul>
  );
}
